import script from "./DanIntegral.vue?vue&type=script&setup=true&lang=js"
export * from "./DanIntegral.vue?vue&type=script&setup=true&lang=js"

import "./DanIntegral.vue?vue&type=style&index=0&id=8f78214a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f78214a"]])

export default __exports__